// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-invoice-generation-page {
  display: flex;
  flex-direction: column;
  padding: 25px;
}

  .bulk-invoice-generation-page__subtitle {
    color: #5D5F62;
    margin-bottom: 20px;
    width: 656px;
  }

  .bulk-invoice-generation-page__csv-upload-container {
    display: flex;
    margin-bottom: 20px;
  }

  .bulk-invoice-generation-page__label {
    display: flex;
    align-self: center;
    color: var(--color-gray-6);
  }

  .bulk-invoice-generation-page__file-upload {
    width: 230px;
    height: 30px;
    padding: 0 16px;
  }

  .bulk-invoice-generation-page__file {
    display: flex;
    align-items: center;
    height: 34px;
    float: left;
    padding: 0 12px;
  }

  .bulk-invoice-generation-page-ok {
    background-color: var(--color-green-1);
  }

  .bulk-invoice-generation-page-error {
    background-color: var(--color-red-1);
  }

  .bulk-invoice-generation-page__formatting {
  display: flex;
  background-color: #F6F6F7;
  padding: 24px;
  align-content: space-between;
  max-width: 1044px;
  }

  .bulk-invoice-generation-page__formatting-instructions {
      margin-right: 24px;
    }

  .bulk-invoice-generation-page__formatting-title {
      color: var(--color-gray-6);
      font-weight: 500;
      font-size: 18px;
      margin-bottom: 10px;
    }

  .bulk-invoice-generation-page__formatting-sub-title {
      color: var(--color-gray-6);
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 10px;
    }

  .bulk-invoice-generation-page__formatting-columns {
      margin-top: 20px;
    }

  .bulk-invoice-generation-page__formatting-columnn {
      margin-top: 20px;
    }

  .bulk-invoice-generation-page__formatting-bold {
      font-weight: 600;
    }

  .bulk-invoice-generation-page__excel-example {
    height: 174px;
    width: 453px;
  }

  .bulk-invoice-generation-page__errors{
    display: flex;
    background-color: var(--color-red-1);
    margin-top: 16px;
    padding: 16px;
  }

  .bulk-invoice-generation-page__icon {
    width: 20px;
    margin-right: 12px;
    color: var(--color-red-3);
  }

  .bulk-invoice-generation-page__error-message-container {
    font-family: Helvetica, Arial, sans-serif;
    font-size: 14px;
    margin-bottom: 5px;
    line-height: 20px;
  }

  .bulk-invoice-generation-page__error-title {
    font-weight: 600;
    color: var(--color-gray-6);
  }

  .bulk-invoice-generation-page__error-text {
    font-size: 14px;
    line-height: 20px;
    color: var(--color-gray-6);
  }

  .bulk-invoice-generation-page__ul {
    padding: 0 24px;
    margin: 0
  }
`, "",{"version":3,"sources":["webpack://./app/_blessed/components/features/ArAp/features/BulkInvoiceGeneration/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AAwHf;;EAtHE;IACE,cAAc;IACd,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAGD;EACC,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,4BAA4B;EAC5B,iBAAiB;EA+BjB;;EA7BE;MACE,kBAAkB;IACpB;;EAEA;MACE,0BAA0B;MAC1B,gBAAgB;MAChB,eAAe;MACf,mBAAmB;IACrB;;EAEA;MACE,0BAA0B;MAC1B,gBAAgB;MAChB,eAAe;MACf,mBAAmB;IACrB;;EAEA;MACE,gBAAgB;IAClB;;EAEA;MACE,gBAAgB;IAClB;;EAEA;MACE,gBAAgB;IAClB;;EAGF;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf;EACF","sourcesContent":[".bulk-invoice-generation-page {\n  display: flex;\n  flex-direction: column;\n  padding: 25px;\n\n  &__subtitle {\n    color: #5D5F62;\n    margin-bottom: 20px;\n    width: 656px;\n  }\n\n  &__csv-upload-container {\n    display: flex;\n    margin-bottom: 20px;\n  }\n\n  &__label {\n    display: flex;\n    align-self: center;\n    color: var(--color-gray-6);\n  }\n\n  &__file-upload {\n    width: 230px;\n    height: 30px;\n    padding: 0 16px;\n  }\n\n  &__file {\n    display: flex;\n    align-items: center;\n    height: 34px;\n    float: left;\n    padding: 0 12px;\n  }\n\n  &-ok {\n    background-color: var(--color-green-1);\n  }\n  \n  &-error {\n    background-color: var(--color-red-1);\n  }\n\n\n &__formatting {\n  display: flex;\n  background-color: #F6F6F7;\n  padding: 24px;\n  align-content: space-between;\n  max-width: 1044px;\n\n    &-instructions {\n      margin-right: 24px;\n    }\n\n    &-title {\n      color: var(--color-gray-6);\n      font-weight: 500;\n      font-size: 18px;\n      margin-bottom: 10px;\n    }\n\n    &-sub-title {\n      color: var(--color-gray-6);\n      font-weight: 500;\n      font-size: 14px;\n      margin-bottom: 10px;\n    }\n\n    &-columns {\n      margin-top: 20px;\n    }\n\n    &-columnn {\n      margin-top: 20px;\n    }\n\n    &-bold {\n      font-weight: 600;\n    }\n  }\n\n  &__excel-example {\n    height: 174px;\n    width: 453px;\n  }\n\n  &__errors{\n    display: flex;\n    background-color: var(--color-red-1);\n    margin-top: 16px;\n    padding: 16px;\n  }\n\n  &__icon {\n    width: 20px;\n    margin-right: 12px;\n    color: var(--color-red-3);\n  }\n\n  &__error-message-container {\n    font-family: Helvetica, Arial, sans-serif;\n    font-size: 14px;\n    margin-bottom: 5px;\n    line-height: 20px;\n  }\n\n  &__error-title {\n    font-weight: 600;\n    color: var(--color-gray-6);\n  }\n\n  &__error-text {\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--color-gray-6);\n  }\n\n  &__ul {\n    padding: 0 24px;\n    margin: 0\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
